import * as yup from "yup";
import { GdkSocialSecurityNumber } from "@gdk/social-security-number";
import { GdkFein } from "@gdk/fein";

/**
 * @param {import('react').MutableRefObject<GdkSocialSecurityNumber>} gdkSsnRef
 * @param {import('react').MutableRefObject<GdkFein>} gdkFeinRef
 * @param {boolean} isSoleProprietor
 */
export default function getBankingInformationSchema(isSoleProprietor) {
    return yup.object({
        ssn: yup.string()
            .transform((value) => value ? value.replace(/-/g, '') : value)
            .test("length", "Please enter a valid SSN", value => !value || value.length === 9)
            .when([], {
                is: () => isSoleProprietor,
                then: schema => schema.required("Please enter Tax Identification Number")
            }),
        fein: yup.string()
            .transform((value) => value ? value.replace(/-/g, '') : value)
            .test("length", "Please enter a valid FEIN", value => !value || value.length === 9)
            .when([], {
                is: () => !isSoleProprietor,
                then: schema => schema.required("Please enter Tax Identification Number")
            }),
        payeeName: yup.string().required("Please enter Payee Name"),
        accountType: yup.string().required("Please make a selection."),
        routingNumber: yup.string().required("Please enter Routing Number"),
        bankName: yup.string().required("Please enter your bank name"),
        accountNumber: yup.string().required("Please enter Account Number"),
        reenterAccountNumber: yup.string()
            .when("accountNumber", (accountNumber) => {
                if (accountNumber) {
                    return yup.string().oneOf([yup.ref('accountNumber')], 'Account number does not match.');
                }
            })
    });
}
